import React from "react";
import { useLocation } from "react-router-dom";
import BillingCheckoutForm from "./BillingCheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Helmet } from "react-helmet";

const stripePromise = loadStripe(
  "pk_test_51StxRy1ilWNnlalf9SjVqO0KzCNv3F8Ognvd2r1EUdjBuNUg9hXZ2I6F6SKKIhSM8Q6VWza52L01XzgKsfqC0jCI00j0H42BYM"
);

function BillingCheckout() {

  const location = useLocation();
  const { plan } = location.state;

  console.log("subscriptionData:", plan);

 

  return (
    
    <Elements stripe={stripePromise}>
       <Helmet>
        <title>PrepNexis – AI-Powered PTE Practice Platform</title>
        <meta
          name="description"
          content="PrepNexis helps you prepare for the PTE exam with AI mock tests, instant scoring, and personalized feedback."
        />
        <meta
          name="keywords"
          content="PrepNexis, PTE prep, AI mock tests, PTE practice, PTE scoring"
        />
      </Helmet>
      <BillingCheckoutForm subscriptionData={plan}/>
    </Elements>
  );
}

export default BillingCheckout;
